export interface ThemeInterface {
    primary: string;
    secondary: string;
    gray: string;
    lightGray: string;
    text: string;
    textInverted: string;
    background: string;
}

const theme: ThemeInterface = {
    primary: '#095482',
    secondary: '#1B7CB7',
    gray: '#8C8C8C',
    lightGray: '#ddd',
    text: '#292929',
    textInverted: 'white',
    background: 'white'
};
export default theme;



// WEBPACK FOOTER //
// ./src/theme.ts